import { useEffect, useState } from 'react'
import type { ReturnTypeWorkflow } from './types'
export function WorkflowHistory({ flow }: { flow: ReturnTypeWorkflow }) {
  const [now, setNow] = useState(Date.now())
  const expiry = typeof flow.view?.expires_at === 'string' ? Date.parse(flow.view.expires_at) : NaN
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined
    const tick = () => {
      setNow(Date.now())
      const remaining = expiry - Date.now() + 1
      if (Number.isFinite(remaining) && remaining > 0)
        timer = setTimeout(tick, Math.min(2147483647, remaining))
    }
    tick()
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [expiry])
  const state =
    flow.view?.state === 'active' && Number.isFinite(expiry) && expiry <= now
      ? 'expired'
      : flow.view?.state
  return (
    <section aria-label="Original command history" className="space-y-3">
      {flow.error && <p role="alert">{flow.error}</p>}
      {flow.view && (
        <p role="status">
          Recorded outcome: {String(state ?? flow.view.decision ?? 'confirmed')}.{' '}
          {flow.view.authority_granted === false
            ? 'This record does not itself grant data access.'
            : ''}
        </p>
      )}
      {flow.references.map(r => (
        <div key={r.kind + ':' + r.command} className="border rounded p-3 space-y-2">
          <p>
            {r.kind} · {r.status === 'pending' ? 'Outcome unconfirmed' : 'Recorded'}
          </p>
          <p className="break-all text-sm">Original reference: {r.command}</p>
          <button className="btn" disabled={flow.busy} onClick={() => void flow.run(r)}>
            Check original outcome
          </button>
          {r.kind === 'prepare' && r.status === 'pending' && r.preparation && (
            <button className="btn" disabled={flow.busy || flow.broken} onClick={() => void flow.retryPreparation(r)}>
              Retry original preparation
            </button>
          )}
        </div>
      ))}
    </section>
  )
}
